export default "__VITE_ASSET__Cb20UU9k__"